import styled from "styled-components";

const ButtonContainer = styled.div`
  width: 100%;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  margin-top: 7.5%;
    
  @media(min-width: 450px) {
    width: 450px;
  }
`;

export {
  ButtonContainer,
};